
import { IMonHocSelectRequest } from '../../../model/request/tkb/IMonHocSelectRequest';
import { INhomLopSelectRequest } from '../../../model/request/tkb/INhomLopSelectRequest';
import { INhomLopUpdateTKBRequest } from '../../../model/request/tkb/INhomLopUpdateTKBRequest';
import { ISuKienSelectRequest } from "../../../model/request/tkb/ISuKienSelectRequest";
import { ISuKienUpdateRequest } from '../../../model/request/tkb/ISuKienUpdateRequest';
import { IXepTKBSelectByBoMonRequest } from '../../../model/request/tkb/IXepTKBSelectByBoMonRequest';
import { IMonHoc } from '../../../model/respone/category/IMonHoc';
import { IStuNhomLopViewModel } from '../../../model/respone/category/IStuNhomLopViewModel';
import { IKeHoachMonViewModel } from '../../../model/respone/ke-hoach/IKeHoachMonViewModel';
import { INhomLopUpdateTKBRespone } from '../../../model/respone/lop-tin-chi/INhomLopUpdateTKBRespone';
import { ISuKienViewModel } from '../../../model/respone/lop-tin-chi/ISuKienViewModel';
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eXepTKBActionsObj = {
  LOAD_SU_KIEN_START: {} as ISuKienSelectRequest,
  LOAD_SU_KIEN_SUCCESS: {} as ISuKienViewModel[],
  LOAD_SU_KIEN_ERRR: "",

  CHANGE_FILTER: {} as ISuKienSelectRequest,
  LOAD_ALL_START: {} as IXepTKBSelectByBoMonRequest,
  LOAD_ALL_SUCCESS: {} as any,
  LOAD_ALL_ERRR: "",

  UPDATE_SUKIEN_START: {} as ISuKienUpdateRequest,
  UPDATE_SUKIEN_SUCCESS: {} as ISuKienViewModel[],
  UPDATE_SUKIEN_ERRR: "",
  // Server báo trùng (phòng/giảng viên) có thể ghi đè -> chờ người dùng xác nhận rồi gửi lại isConfirmTrung=true
  UPDATE_SUKIEN_TRUNG: {} as { request: ISuKienUpdateRequest; message: string },
  // Realtime: người khác cùng đợt vừa đổi sự kiện -> patch board tại chỗ (SignalR SU_KIEN_CHANGED)
  PATCH_SUKIENS: {} as ISuKienViewModel[],

  UPDATE_NHOMLOP_INFO: {} as IStuNhomLopViewModel,


  CHANGE_NHOMLOP_ID: 0,
  CHANGE_NHOMLOP_GHEPCAP_ID: 0,
  CHANGE_KEHOACHMON_SELECTED: {} as IKeHoachMonViewModel | undefined,

  LOAD_MON_HOC_START: {} as IMonHocSelectRequest,
  LOAD_MON_HOC_SUCCESS: {} as IMonHoc[],
  LOAD_MON_HOC_ERRR: "",

  LOAD_MON_HOC_CHUA_HT_START: {} as IMonHocSelectRequest,
  LOAD_MON_HOC_CHUA_HT_SUCCESS: {} as number[],
  LOAD_MON_HOC_CHUA_HT_ERRR: "",

  LOAD_NHOM_LOP_START: {} as INhomLopSelectRequest,
  LOAD_NHOM_LOP_SUCCESS: {} as IStuNhomLopViewModel[],
  LOAD_NHOM_LOP_ERRR: "",

  UPDATE_GV_PH_SUKIEN_START: {} as ISuKienUpdateRequest,
  UPDATE_GV_PH_SUKIEN_SUCCESS: {} as ISuKienViewModel[],
  UPDATE_GV_PH_SUKIEN_ERRR: "",

  UPDATE_PHONG_HOC_SUKIEN_START: {} as ISuKienUpdateRequest,
  UPDATE_PHONG_HOC_SUKIEN_SUCCESS: {} as ISuKienViewModel[],
  UPDATE_PHONG_HOC_SUKIEN_ERRR: "",

  UPDATE_NHOMLOP_SUKIEN_START: {} as INhomLopUpdateTKBRequest,
  UPDATE_NHOMLOP_SUKIEN_SUCCESS: {} as INhomLopUpdateTKBRespone,
  UPDATE_NHOMLOP_SUKIEN_ERROR: "",

  CHANGE_MODE_DISPLAY: {} as "all" | "chua-xep",

};
export const eXepTKBActionIds = generateActionTypeIds(
  eXepTKBActionsObj,
  "XEP_TKB"
);
export type IXepTKBActionTypes = IGenericActionType<
  typeof eXepTKBActionsObj,
  "XEP_TKB"
>;
